<div class="modal-header">
    <h5 class="modal-title">{{ purchaseSuggestion.id ? 'Chỉnh sửa' : 'Thêm' }} Gợi Ý Mua Sắm</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="title">
          Tiêu Đề
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập tiêu đề của tác phẩm."></i>
        </label>
        <input type="text" class="form-control" id="title" [(ngModel)]="purchaseSuggestion.title" name="title" placeholder="ví dụ: Đại Gia Gatsby">
      </div>
      <div class="form-group">
        <label for="author">
          Tác Giả
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn tác giả của tác phẩm."></i>
        </label>
        <select class="form-control" id="author" [(ngModel)]="purchaseSuggestion.author" name="author">
          <option *ngFor="let writer of writers" [ngValue]="writer">{{ writer.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="copyrightDate">
          Ngày Bản Quyền
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn ngày bản quyền của tác phẩm."></i>
        </label>
        <input type="date" class="form-control" id="copyrightDate" [(ngModel)]="purchaseSuggestion.copyrightDate" name="copyrightDate" placeholder="ví dụ: 2023-10-03">
      </div>
      <div class="form-group">
        <label for="isbnIssnOtherStandardNumber">
          ISBN/ISSN/Số Tiêu Chuẩn Khác
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập ISBN, ISSN, hoặc số tiêu chuẩn khác."></i>
        </label>
        <input type="text" class="form-control" id="isbnIssnOtherStandardNumber" [(ngModel)]="purchaseSuggestion.isbnIssnOtherStandardNumber" name="isbnIssnOtherStandardNumber" placeholder="ví dụ: 978-3-16-148410-0">
      </div>
      <div class="form-group">
        <label for="publisher">
          Nhà Xuất Bản
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn nhà xuất bản của tác phẩm."></i>
        </label>
        <select class="form-control" id="publisher" [(ngModel)]="purchaseSuggestion.publisher" name="publisher">
          <option *ngFor="let publisher of publishers" [ngValue]="publisher">{{ publisher.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="publicationPlace">
          Nơi Xuất Bản
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập nơi xuất bản của tác phẩm."></i>
        </label>
        <input type="text" class="form-control" id="publicationPlace" [(ngModel)]="purchaseSuggestion.publicationPlace" name="publicationPlace" placeholder="ví dụ: New York">
      </div>
      <div class="form-group">
        <label for="collectionTitle">
          Tiêu Đề Bộ Sưu Tập
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập tiêu đề của bộ sưu tập nếu có."></i>
        </label>
        <input type="text" class="form-control" id="collectionTitle" [(ngModel)]="purchaseSuggestion.collectionTitle" name="collectionTitle" placeholder="ví dụ: Văn Học Kinh Điển">
      </div>
      <div class="form-group">
        <label for="mediaType">
          Loại Phương Tiện
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn loại phương tiện của tác phẩm."></i>
        </label>
        <select class="form-control" id="mediaType" [(ngModel)]="purchaseSuggestion.mediaType" name="mediaType">
          <option *ngFor="let mediaType of mediaTypes" [ngValue]="mediaType">{{ mediaType.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="reasonForSuggestion">
          Lý Do Gợi Ý
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Giải thích lý do tại sao tác phẩm này được gợi ý."></i>
        </label>
        <textarea class="form-control" id="reasonForSuggestion" [(ngModel)]="purchaseSuggestion.reasonForSuggestion" name="reasonForSuggestion" placeholder="ví dụ: Được các chuyên gia khuyến nghị."></textarea>
      </div>
      <div class="form-group">
        <label for="notes">
          Ghi Chú
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Thêm bất kỳ ghi chú bổ sung nào tại đây."></i>
        </label>
        <textarea class="form-control" id="notes" [(ngModel)]="purchaseSuggestion.notes" name="notes" placeholder="ví dụ: Xem xét cho các lần mua sắm sau."></textarea>
      </div>
      <div class="form-group">
        <label for="fund">
          Quỹ
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn nguồn tài trợ."></i>
        </label>
        <select class="form-control" id="fund" [(ngModel)]="purchaseSuggestion.fund" name="fund">
          <option *ngFor="let fund of funds" [ngValue]="fund">{{ fund.fundName }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="showInactive">
          Hiển Thị Không Hoạt Động
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Đánh dấu để bao gồm các mục không hoạt động."></i>
        </label>
        <input type="checkbox" id="showInactive" [(ngModel)]="purchaseSuggestion.showInactive" name="showInactive">
      </div>
      <div class="form-group">
        <label for="copies">
          Số Bản Sao
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập số lượng bản sao được yêu cầu."></i>
        </label>
        <input type="number" class="form-control" id="copies" [(ngModel)]="purchaseSuggestion.copies" name="copies" placeholder="ví dụ: 1">
      </div>
      <div class="form-group">
        <label for="currency">
          Loại Tiền Tệ
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập loại tiền tệ (ví dụ: USD, EUR)."></i>
        </label>
        <input type="text" class="form-control" id="currency" [(ngModel)]="purchaseSuggestion.currency" name="currency" placeholder="ví dụ: USD">
      </div>
      <div class="form-group">
        <label for="price">
          Giá
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập giá của mục."></i>
        </label>
        <input type="number" class="form-control" id="price" [(ngModel)]="purchaseSuggestion.price" name="price" step="0.01" placeholder="ví dụ: 19.99">
      </div>
      <div class="form-group">
        <label for="total">
          Tổng Cộng
          <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập tổng chi phí cho số lượng bản sao được yêu cầu."></i>
        </label>
        <input type="number" class="form-control" id="total" [(ngModel)]="purchaseSuggestion.total" name="total" step="0.01" placeholder="ví dụ: 39.98">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Hủy</button>
    <button type="button" class="btn btn-outline-primary" (click)="onSaveClick()">Lưu</button>
  </div>

